export const precisionRounding = (value: number, precision?: number): number => {
  const power = Math.pow(10, precision || 2);
  return Math.round(value * power) / power;
};
